import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/RiwayatPerkawinanRalan";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "riwayat-perkawinan-ralan"
})
class RiwayatPerkawinanRalanStore extends VuexModule {
  loading = false;
  data: any = null;

  @Mutation
  SET_RECORD(val) {
    this.data = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.data = null;
    this.loading = false;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RECORD(response.data?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(RiwayatPerkawinanRalanStore);
